import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DashboardDataTable from 'modules/common/dashboardDataTable.component';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  noData: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
}));

const formatCurrency = (amount) => {
  if (amount == null) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

// One pre-aggregated summary row per expense analyst, straight from the API
const EaExpenseOverviewGrid = ({ summaries, isLoading }) => {
  const classes = useStyles();

  const columns = [
    {
      accessorKey: 'expenseAnalystName',
      header: 'Expense Analyst',
      Cell: ({ cell }) => cell.getValue() || '-',
    },
    {
      accessorKey: 'activeFileCount',
      header: 'Active Files',
    },
    {
      accessorKey: 'expenseCount',
      header: '# of Expenses',
    },
    {
      accessorKey: 'allLineItemsApprovedExpenseCount',
      header: 'Approved',
    },
    {
      accessorKey: 'allLineItemsDeniedExpenseCount',
      header: 'Denied',
    },
    {
      accessorKey: 'totalExpenseAmount',
      header: 'Total Amount',
      Cell: ({ cell }) => formatCurrency(cell.getValue()),
    },
    {
      accessorKey: 'totalApprovedLineItemAmount',
      header: 'Approved Amount',
      Cell: ({ cell }) => formatCurrency(cell.getValue()),
    },
  ];

  if (isLoading) {
    return (
      <Paper elevation={0} className={classes.tableContainer}>
        <Typography className={classes.noData} color="textSecondary">
          Loading expense overview...
        </Typography>
      </Paper>
    );
  }

  if (summaries.length === 0) {
    return (
      <Paper elevation={0} className={classes.tableContainer}>
        <Typography className={classes.noData} color="textSecondary">
          No expense analyst summaries to display
        </Typography>
      </Paper>
    );
  }

  return (
    <Box className={classes.tableContainer}>
      <DashboardDataTable
        columns={columns}
        data={summaries}
        initialSorting={[{ id: 'expenseAnalystName', desc: false }]}
      />
    </Box>
  );
};

EaExpenseOverviewGrid.propTypes = {
  summaries: PropTypes.arrayOf(
    PropTypes.shape({
      expenseAnalystName: PropTypes.string,
      activeFileCount: PropTypes.number,
      expenseCount: PropTypes.number,
      allLineItemsApprovedExpenseCount: PropTypes.number,
      allLineItemsDeniedExpenseCount: PropTypes.number,
      totalExpenseAmount: PropTypes.number,
      totalApprovedLineItemAmount: PropTypes.number,
    }),
  ).isRequired,
  isLoading: PropTypes.bool,
};

EaExpenseOverviewGrid.defaultProps = {
  isLoading: false,
};

export default EaExpenseOverviewGrid;
